import { render, staticRenderFns } from "./CityDropdown.vue?vue&type=template&id=138e90d0"
import script from "./CityDropdown.vue?vue&type=script&lang=js"
export * from "./CityDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports